// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberExtension",
        "baseName": "phoneNumberExtension",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel.js.map